<angular-editor *ngIf="!disabled" [ngClass]="{'editor-warning': !valid, 'editor-alternative-marker': alternativeHint}"
                [id]="id"
                [placeholder]="placeholder | translate" [config]="config"
                (focusin)="editorFocused = true" (focusout)="editorFocused = false"
                [(ngModel)]="model" (ngModelChange)="modelChanged.emit()"></angular-editor>
<div *ngIf="disabled" [innerHTML]="model" class="bottom-spacer"></div>
<ng-container *ngIf="valid">
  <small class="text-muted" *ngIf="!alternativeHint && hint">
    <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
    {{ hint | translate }}
  </small>
  <small class="text-muted" *ngIf="alternativeHint">
    <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
    {{ alternativeHint | translate }}
    <span class="text-secondary">*</span>
  </small>
</ng-container>
<small class="text-warning" *ngIf="!valid">
  <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
  {{ (error ? error : 'general.api_editor_content_invalid') | translate }}
</small>
